import { DefaultUISettings, Service, TCFUISettings, UI_VARIANT } from '@usercentrics/cmp-browser-sdk';
import { FunctionalComponent, h } from 'preact';
import {
  SubServiceDetailBackArrow,
  SubServiceDetailBackButton,
  SubServiceDetailContainer,
  SubServiceDetailContent,
  SubServiceDetailContentWrapper,
  SubServiceDetailHeader,
  SubServiceDetailNav,
  SubServiceDetailTitle,
} from './SubServices.styles';
import ServiceItem from '../ServicesListItem/ServicesListItem';
import { useSettingsContext } from '../../contexts/SettingsContext';
import { useUiContext } from '../../contexts/UiContext';

interface Props {
  onCloseDetail: () => void;
  subService: Service;
}

const SubServiceDetail: FunctionalComponent<Props> = ({ subService, onCloseDetail }) => {
  const { uiVariant } = useUiContext();
  const { settings } = useSettingsContext();
  const backLabel =
    uiVariant === UI_VARIANT.TCF
      ? (settings.ui as TCFUISettings).labels.nonTCFLabels.general.back
      : (settings.ui as DefaultUISettings).labels.general.back;

  return (
    <SubServiceDetailContainer>
      <SubServiceDetailNav>
        <SubServiceDetailBackButton type="button" onClick={onCloseDetail}>
          <SubServiceDetailBackArrow direction="left" />
          {backLabel}
        </SubServiceDetailBackButton>
      </SubServiceDetailNav>

      <SubServiceDetailContentWrapper>
        <SubServiceDetailHeader>
          <SubServiceDetailTitle role="heading" aria-level={2}>
            {subService.name}
          </SubServiceDetailTitle>
        </SubServiceDetailHeader>

        <SubServiceDetailContent>
          <ServiceItem service={subService} />
        </SubServiceDetailContent>
      </SubServiceDetailContentWrapper>
    </SubServiceDetailContainer>
  );
};

export default SubServiceDetail;
